//@file src/state/modules/dashboard/videos.js
import Vue from 'vue'
import Vuex from 'vuex'

import { vuexfireMutations } from 'vuexfire'

//import createPersistedState from "vuex-persistedstate";
import user from "./user"
import auth from "./auth"

Vue.use(Vuex)
//import firebase from "firebase/compat/app";
 //from "firebase/compat/f"
 import {firestore} from "@/_services/firebase/db.js";
import conversations from './conversations/conversations'




Vue.use(Vuex)

const state = {
	db: firestore
}

const store = new Vuex.Store({
   state,
   // strict: process.env.NODE_ENV !== 'production',
    modules: {
    
  
         user,
         auth,
         conversations

          },  
       //   plugins: [createPersistedState()],

          mutations: {
          ...vuexfireMutations
          },
        
  })

  export default store 